export default __webpack_public_path__ + "static/1-text-shadow-c8b8ff1afd4d9fc6538276ac6f39422d.gif";